import { Icon } from '@iconify/react/dist/iconify.js';
import TextField from '@mui/material/TextField';
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { SOCIETY_CONTROLLER, SOCIETY_BRAND } from '../../../../../Routing/routes';
import { ErrorMessage, Form, Formik } from 'formik';
import { addBrandSchema } from '../../../../../validationSchema/SocietyController/Brand/BrandSchema';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { createBrand, editBrand } from '../../../../../redux/actions/SocietyController/CtrlBrandAction/CtrlBrand';
import { CircularProgress } from '@mui/material';

const InputCustomStyles = ({ isEditMode = false, brandId = null, data }) => {
    const navigate = useNavigate();
    const formRef = useRef(null)
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        emailSuffix: '',
        senderId: '',
        website: '',
        contactEmail: '',
        contactPhone: '',
        androidAppLink: '',
        iosAppLink: '',
        logo: null, // To hold the file object
    });
    const [logoPreview, setLogoPreview] = useState(null); // To hold the preview URL
    const [existingLogoUrl, setExistingLogoUrl] = useState('');
    // eslint-disable-next-line no-unused-vars
    const { createLoading, detailsLoading, _brandDetails } = useSelector(state => state.CtrlBrandReducers)
    const dispatch = useDispatch()
    // Fetch brand data when in edit mode
    useEffect(() => {
        if (isEditMode && brandId) {
            // dispatch(getBrand({ id: brandId }))
        }
    }, [isEditMode, brandId]);
    const location = useLocation();
    const { state } = location;
    const editData = state?.data || '';
    // eslint-disable-next-line no-unused-vars
    const _handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // eslint-disable-next-line no-unused-vars
    const _handleLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prev => ({ ...prev, logo: file }));
            const previewUrl = URL.createObjectURL(file);
            setLogoPreview(previewUrl);
        }
    };

    // eslint-disable-next-line no-unused-vars
    const _removeLogo = () => {
        setFormData(prev => ({ ...prev, logo: null }));
        if (logoPreview) {
            URL.revokeObjectURL(logoPreview);
            setLogoPreview(null);
        }
        setExistingLogoUrl(''); // Also remove existing logo if user decides to remove it
    };

    // eslint-disable-next-line no-unused-vars
    const _handleReset = () => {
        if (isEditMode) {
            // Reset to original data when editing
            // TODO: Reset to fetched data
        } else {
            setFormData({
                name: '',
                description: '',
                emailSuffix: '',
                senderId: '',
                website: '',
                contactEmail: '',
                contactPhone: '',
                androidAppLink: '',
                iosAppLink: '',
                logo: null,
            });
            if (logoPreview) {
                URL.revokeObjectURL(logoPreview);
            }
            setLogoPreview(null);
            setExistingLogoUrl('');
        }
    };

    // eslint-disable-next-line no-unused-vars
    const _handleSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData();
        Object.keys(formData).forEach(key => {
            if (key === 'logo' && formData.logo) {
                data.append(key, formData.logo);
            } else if (formData[key] !== null && key !== 'logo') {
                data.append(key, formData[key]);
            }
        });

        // For debugging
        for (let [key, value] of data.entries()) {
            console.log(key, value);
        }

        try {
            if (isEditMode) {
                // TODO: Call API to update brand with FormData
                console.log('Updating brand:', brandId, data);
            } else {
                // TODO: Call API to create brand with FormData
                console.log('Creating brand:', data);
            }
            // Navigate back to brand list after success
            navigate(SOCIETY_CONTROLLER + SOCIETY_BRAND);
        } catch (error) {
            console.error('Error saving brand:', error);
        }
    };

    const textFieldStyles = {
        '& .MuiInputLabel-root': {
            fontSize: '14px',
        },
    };

    // eslint-disable-next-line no-unused-vars
    const _finalLogoPreview = logoPreview || existingLogoUrl;


    return (
        <div className="col-lg-12">
            <Formik
                initialValues={
                    isEditMode ? { brandName: editData?.title, logo_url: editData?.logoUrl, description: editData?.description, website: editData?.website } :
                        {
                            brandName: '',
                            logo_url: '',
                            description: '',
                            website: '',
                        }}
                enableReinitialize
                validationSchema={addBrandSchema()}
                onSubmit={(values, { resetForm, setSubmitting }) => {
                    if (brandId) dispatch(editBrand({
                        ...values,
                        id: brandId,
                        onSuccess: () => {
                            navigate(SOCIETY_CONTROLLER + SOCIETY_BRAND);
                            resetForm();
                        }
                    }));
                    else dispatch(createBrand({
                        ...values,
                        onSuccess: () => {
                            navigate(SOCIETY_CONTROLLER + SOCIETY_BRAND);
                            resetForm();
                        }
                    }));

                    setSubmitting(false);
                }}
                innerRef={(f) => (formRef.current = f)}

            >
                {(formik) => {
                    return (
                        <Form>
                            <div className="card">
                                <div className="card-header tw-flex tw-justify-between tw-items-center tw-gap-3 tw-flex-wrap">
                                    <div className='tw-flex tw-items-center tw-gap-2'>
                                        <button
                                            type='button'
                                            onClick={() => navigate(-1)}
                                            className='tw-h-8 tw-w-8 tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-text-gray-500 hover:tw-bg-gray-100 hover:tw-text-rose-600 tw-transition-colors tw-border-0'
                                        >
                                            <Icon icon="solar:alt-arrow-left-outline" className="tw-text-base" />
                                        </button>
                                        <h5 className="tw-text-sm tw-font-bold tw-text-gray-800 tw-mb-0">
                                            {isEditMode ? `Edit Brand Details (ID: ${brandId})` : 'Provide Brand Details'}
                                        </h5>
                                    </div>
                                    <div className='tw-flex tw-gap-2'>
                                        <button
                                            type="button"
                                            disabled={detailsLoading || createLoading}
                                            className="tw-h-8 tw-inline-flex tw-items-center tw-gap-1 tw-px-3 tw-rounded-md tw-text-xs tw-font-medium tw-text-gray-600 tw-bg-white tw-border tw-border-gray-200 hover:tw-bg-gray-50 disabled:tw-opacity-50"
                                            onClick={() => { formik.resetForm() }}
                                        >
                                            {(detailsLoading || createLoading)
                                                ? <span className='tw-animate-spin tw-rounded-full tw-h-3 tw-w-3 tw-border-2 tw-border-gray-300 tw-border-t-gray-600' />
                                                : <Icon icon="mdi:refresh" className="tw-text-sm" />}
                                            Reset
                                        </button>
                                        <button
                                            type="submit"
                                            disabled={detailsLoading || createLoading}
                                            className="tw-h-8 tw-inline-flex tw-items-center tw-gap-1 tw-px-3 tw-rounded-md tw-text-xs tw-font-medium tw-text-white tw-bg-rose-600 hover:tw-bg-rose-700 disabled:tw-opacity-50 tw-transition-colors"
                                        >
                                            {(detailsLoading || createLoading)
                                                ? <span className='tw-animate-spin tw-rounded-full tw-h-3 tw-w-3 tw-border-2 tw-border-white tw-border-t-transparent' />
                                                : <Icon icon="mdi:check" className="tw-text-sm" />}
                                            {isEditMode ? 'Update' : 'Save'}
                                        </button>
                                    </div>
                                </div>
                                <div className="card-body">

                                    <div className="row gy-3 ">                        {/* Logo Upload Section */}


                                        {/* Brand Name */}
                                        <div className="col-md-4">
                                            <label className="form-label">Brand Name <span className="text-danger">*</span></label>
                                            <div>
                                                <TextField
                                                    name="brandName"
                                                    value={formik.values.brandName}
                                                    label="Enter brand name"
                                                    variant="outlined"
                                                    size="small"
                                                    className='tw-w-full'

                                                    sx={textFieldStyles}
                                                    onInput={(e) => { formik.setFieldValue('brandName', e.target.value) }}
                                                />
                                                <div
                                                    className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}
                                                >
                                                    <ErrorMessage name={`brandName`} />
                                                </div>
                                            </div>
                                        </div>


                                        {/* Website */}
                                        <div className="col-md-4">
                                            <label className="form-label">Website</label>
                                            <div>
                                                <TextField
                                                    name="website"
                                                    value={formik.values.website}
                                                    onChange={formik.handleChange}
                                                    label="Enter website"
                                                    variant="outlined"
                                                    size="small"
                                                    className='tw-w-full'
                                                    sx={textFieldStyles}
                                                />
                                                <div
                                                    className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}
                                                >
                                                    <ErrorMessage name={`website`} />
                                                </div>
                                            </div>
                                        </div>
                                        {/* Website */}
                                        <div className="col-md-4">
                                            <label className="form-label">Custom URL</label>
                                            <div>
                                                <TextField
                                                    name="logo_url"
                                                    value={formik.values.logo_url}
                                                    onChange={formik.handleChange}
                                                    label="Enter URL "
                                                    variant="outlined"
                                                    size="small"
                                                    className='tw-w-full'
                                                    sx={textFieldStyles}
                                                />
                                                <div
                                                    className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}
                                                >
                                                    <ErrorMessage name={`logo_url`} />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Description */}
                                        <div className="col-md-12">
                                            <label className="form-label">Description</label>
                                            <div>
                                                <TextField
                                                    name="description"
                                                    value={formik.values.description}
                                                    onChange={formik.handleChange}
                                                    label="Enter brand description"
                                                    variant="outlined"
                                                    size="small"
                                                    multiline
                                                    rows={3}
                                                    className='tw-w-full'
                                                    sx={textFieldStyles}
                                                />
                                                <div
                                                    className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}
                                                >
                                                    <ErrorMessage name={`description`} />
                                                </div>
                                            </div>
                                        </div>

                                        {/* <div className="col-md-8">
                                        <label className="form-label">Brand Logo</label>
                                        <div className="d-flex align-items-center gap-4">
                                            <Avatar
                                                src={finalLogoPreview}
                                                sx={{ width: 80, height: 80, borderRadius: '8px', border: '1px solid #eee' }}
                                                variant="rounded"
                                            >
                                                <Icon icon="solar:gallery-bold" className="text-3xl text-gray-400" />
                                            </Avatar>
                                            <div className="d-flex flex-column gap-2">
                                                <div className="d-flex gap-2">
                                                    <label htmlFor="logo-upload" className="btn btn-sm btn-light-primary radius-8">
                                                        <Icon icon="solar:upload-outline" className="me-1" />
                                                        {finalLogoPreview ? 'Change' : 'Upload'}
                                                    </label>
                                                    <input
                                                        type="file"
                                                        id="logo-upload"
                                                        hidden
                                                        accept="image/png, image/jpeg, image/gif"
                                                        onChange={handleLogoChange}
                                                    />
                                                    {finalLogoPreview && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-light-danger radius-8"
                                                            onClick={removeLogo}
                                                        >
                                                            <Icon icon="solar:trash-bin-trash-outline" className="me-1" />
                                                            Remove
                                                        </button>
                                                    )}
                                                </div>
                                                <span className="text-xs text-gray-500">
                                                    Allowed *.jpeg, *.jpg, *.png, *.gif. Max size of 2 MB.
                                                </span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center gap-4 tw-mt-6 ">
                                            <TextField
                                                name="description"
                                                value={formData.description}
                                                onChange={handleChange}
                                                label="Custom URL"
                                                variant="outlined"
                                                size="small"
                                                multiline
                                                rows={1}
                                                className='tw-w-full'
                                                sx={textFieldStyles}
                                            />
                                        </div>
                                    </div> */}


                                    </div>

                                </div>
                            </div>
                        </Form>
                    )
                }}
            </Formik >
        </div >
    );
};

export default InputCustomStyles;
